import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-gold/20 bg-cream-dark/20 text-center" data-id="element-39">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-40">
        <div className="text-xl font-serif tracking-widest text-charcoal/50 uppercase mb-6" data-id="element-41">
          Belleza<span className="italic font-light" data-id="element-42">Latina</span>
        </div>
        <p className="text-xs font-sans text-charcoal-light/60 max-w-2xl leading-relaxed mb-4" data-id="element-43">
          Esta página es de carácter informativo y educativo. Los resultados
          pueden variar según la constancia y la anatomía individual. La Yoga
          Facial no sustituye el consejo médico profesional.
        </p>
        <div className="flex gap-6 text-xs text-charcoal-light/60 uppercase tracking-wider" data-id="element-44">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-45">
            Privacidad
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-46">
            Términos
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-47">
            Contacto
          </a>
        </div>
        <p className="mt-8 text-xs text-charcoal-light/40" data-id="element-48">
          &copy; {new Date().getFullYear()} Belleza Latina. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}